
import imgClsCommon from "@/assets/busi-paper/prints/GUOTOU/imgClsCommon.js";

import imgCls04x from "@/assets/busi-paper/prints/GUOTOU/04x.js";
import imgClsXb6 from "@/assets/busi-paper/prints/GUOTOU/Xb6.js";
import imgClsXID from "@/assets/busi-paper/prints/GUOTOU/XID.js";
import imgCls0x3 from "@/assets/busi-paper/prints/GUOTOU/0x3.js";
import imgClsX2r from "@/assets/busi-paper/prints/GUOTOU/X2r.js";

export default {
  GUOTOU: {
    "common": imgClsCommon,
    "04x": imgCls04x,
    "Xb6": imgClsXb6,
    "X24": imgClsXb6,
    "X2p": imgClsXb6,
    "X2F": imgClsXb6,
    "XID": imgClsXID,
    "XIE": imgClsXID,
    "0x3": imgCls0x3,
    "X2r": imgClsX2r,
    "Xb7": imgClsX2r
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/imageNode/child/img-cls-conf.js
// module id = 1130
// module chunks = 2